import React from "react";

// The original vector mouse mark keeps branding crisp and matches the app palette.
export default function Mascot({ size = 120, className = "", style }) {
  return (
    <img
      src="/icon.svg"
      alt="ChoreMouse mascot"
      width={size}
      height={size}
      draggable={false}
      className={`select-none pointer-events-none ${className}`}
      style={{ objectFit: "contain", ...style }}
    />
  );
}

// Compact brand logo (mouse face app icon) — for headers & nav.
export function BrandLogo({ size = 40, className = "" }) {
  return (
    <img
      src="/icon.svg"
      alt="ChoreMouse"
      width={size}
      height={size}
      draggable={false}
      className={`rounded-2xl shadow-claybtn select-none ${className}`}
    />
  );
}
